import type { AccountOperation } from '../../types'

import { call } from 'redux-saga/effects'

import { validateModel } from 'hfty-model-accounts'

export default function *validateOperationSaga (operation: AccountOperation): Generator<*, *, *> {
  const errors = yield call(validateModel, operation.model)

  const nextOperation = {
    ...operation,
    submitting: false,
    errors,
  }

  return nextOperation
}
